export const json_body = (text) => {
  try {
    const v = JSON.parse(typeof text === 'string' ? text : '');
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch (e) {
    return {};
  }
};

export const with_json_error = async (e) => {
  const data = e && e.response && e.response.data;
  if (!data || typeof data.text !== 'function') return e;
  const text = await data.text();
  return { ...e, response: { ...e.response, data: json_body(text) } };
};
